<<template>
    <div class="background-setting-card" v-if="isReady" v-resize="onResize">
        <v-row no-gutters class="standard-row font-theme d-flex justify-end">
            <v-btn height="50" width="141" color="#0B68D6" class="white--text mt-6 mr-6 decorate-search-btn-setting" @click="AddRole()" style="font-size: 20px; border-radius: 10px; letter-spacing: 0px;">
                เพิ่มสิทธิ์
                <svg width="26" height="25" viewBox="0 0 26 25" class="ml-3" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M13 24C19.657 24 25 18.931 25 12.5513C25 6.17171 19.657 1 13 1C6.343 1 1 6.17171 1 12.5513C1 18.931 6.343 24 13 24Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M7 12.5H19" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M13 18.331V6.75" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </v-btn>
            <v-btn height="50" width="235" color="#0B68D6" class="white--text mt-6 mr-6 decorate-search-btn-setting"
                @click="downloadFile()" style="font-size: 20px; border-radius: 10px; letter-spacing: 0px;">
                 Download Report
                <svg width="26" height="25" viewBox="0 0 26 25" class="ml-3" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M13 24C19.657 24 25 18.931 25 12.5513C25 6.17171 19.657 1 13 1C6.343 1 1 6.17171 1 12.5513C1 18.931 6.343 24 13 24Z"
                        stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M13 7.5V15.5" stroke="white" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round" />
                    <path d="M9.5 12.5L13 16L16.5 12.5" stroke="white" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round" />
                    <path d="M8.5 18H17.5" stroke="white" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round" />
                </svg>
            </v-btn>
        </v-row>
        <v-row no-gutters class="standard-row font-theme" style="padding: 0% 3.2% 34px 3.2%">
            <v-row no-gutters class="standard-row font-theme" style="font-size: 36px; font-weight: 700; color: #525252;">
                Setting
            </v-row>
            <v-row no-gutters class="standard-row font-theme mt-3" style="font-size: 20px; font-weight: 700; color: #525252;">
                กำหนดสิทธิ์การใช้งาน : Inbox
            </v-row>
            <v-row no-gutters class="standard-row font-theme white--text mt-3">
                <v-col cols="12" sm="7" md="5" lg="4" class="pr-4">
                    <v-text-field dense outlined hide-details color="black" height="37" background-color="white" v-model="keyword" @keyup.enter="searchKeyword(keyword)" @input="!keyword? searchKeyword(keyword): null" class="font-theme search-role-setting" style="border-radius: 10px; font-size: 20px;">
                        <template v-slot:append v-if="windowSize.x < 600">
                            <v-btn icon @click="searchKeyword(keyword)" style="margin-top: 2px; margin-right: -10px;">
                                <v-icon size="28">mdi-magnify</v-icon>
                            </v-btn>
                        </template>
                    </v-text-field>
                </v-col>
                <v-col v-if="windowSize.x >= 600" cols="4" sm="4" md="auto" lg="auto">
                    <v-btn rounded color="#0B68D6" class="white--text decorate-search-btn-setting" height="40" width="104" @click="searchKeyword(keyword)" style="font-weight: 700; font-size: 20px; border-radius: 10px;">
                        Search
                    </v-btn>
                </v-col>
            </v-row>
            <v-row no-gutters class="standard-row font-theme mt-10">
                <v-data-table :headers="headers" range :items="userPermission" hide-default-footer fixed-header class="elevation-0 setting-page-data-table" style="width: 100%; background-color: rgba(255, 255, 255, 0.4); font-size: 18px;" :options.sync="optionsDataTable" :server-items-length="userPermission.length" mobile-breakpoint="901">
                    <template slot="no-data">
                        <v-alert class="text-center d-flex justify-center" style="background-color: transparent; font-size: 18px;">
                            ไม่พบข้อมูล
                        </v-alert>
                    </template>
                    <template v-slot:[`item.deletePermission`]="{ item }">
                        <v-tooltip top>
                            <template v-slot:activator="{ on }">
                                <v-btn icon v-on="on" color="#333333" @click="deletePermission(item.id)">
                                    <svg width="27" height="22" viewBox="0 0 33 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M5.42871 4.25H27.5716V23.75C27.5716 25.5449 25.5888 27 23.143 27H9.85728C7.41145 27 5.42871 25.5449 5.42871 23.75V4.25ZM16.5001 1C18.946 1 20.9287 2.45507 20.9287 4.25H12.0716C12.0716 2.45507 14.0543 1 16.5001 1Z" stroke="#DD3636" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M1 4.25H32" stroke="#DD3636" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M12.0718 9.125V22.125" stroke="#DD3636" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M20.9282 9.125V22.125" stroke="#DD3636" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </v-btn>
                            </template>
                            <span class="font-theme">ลบสิทธิ์ {{ item.permission }} - {{ item.name }}</span>
                        </v-tooltip>
                    </template>
                </v-data-table>
            </v-row>
            <div v-if="windowSize.x > 901" no-gutters style="height: 57px; background-color: #EEEEEE; border-radius: 0px 0px 10px 10px; width: 100%;">

            </div>
        </v-row>
        <AddPermissionInbox />
    </div>
</template>

<script>
import { EventBus } from '../EventBus'
import { MainFunction } from '@/functions/mainFunction.js'
import AddPermissionInbox from '../components/AddPermissionInbox.vue'

    export default {
        components: {
            AddPermissionInbox
        },
        computed: {
            selectedBiz() {
                return this.$store.state.confirmSelectedBiz
            }
        },
        data: () => ({
            keyword: '',
            isReady: false,
            callApiPending: 0,
            userPermission: [],
            windowSize: { x: 0 },
            holdUserPermission: [],
            optionsDataTable: { page: 1 },
            headers: [
                { text: 'ลำดับ'       , align: 'center', sortable: false, value: 'no'                , width: '5%' },
                { text: 'บริษัท'       , align: 'center', sortable: false, value: 'business'          , width: '22%' },
                { text: 'รหัสพนักงาน'  , align: 'center', sortable: false, value: 'employee_id'       , width: '12%' },
                { text: 'ชื่อ - สกุล'   , align: 'start', sortable: false,  value: 'name'              , width: '25%' },
                { text: 'สิทธิ์'        , align: 'center', sortable: false, value: 'permission'        , width: '13%' },
                { text: 'วันที่ทำรายการ', align: 'center', sortable: false, value: 'created_at'        , width: '17%' },
                { text: ''           , align: 'center', sortable: false, value: 'deletePermission' , width: '10%' }
            ]
        }),
        mounted() {
            this.onResize()
            this.searchPermissionEmp()
            EventBus.$on('AfterAddPermission', this.searchPermissionEmp)
        },
        watch: {
            "callApiPending"(val) {
                if (val > 0) {
                    EventBus.$emit('loadingState', true)
                } else {
                    EventBus.$emit('loadingState', false)
                }
            }
        },
        beforeDestroy () {
            EventBus.$emit('loadingState', false)
            EventBus.$off('AfterAddPermission')
        },
        methods: {
            onResize() {
                this.windowSize = { x: window.innerWidth }
            },
            AddRole() {
                EventBus.$emit('addPermissionInboxModal')
            },
            async searchPermissionEmp() {
                try {
                    this.callApiPending++
                    const { data } = await this.axios.get(`${this.$api_url}/permission/api/v1/search_permission`)
                    if (data.status && data.data.length) {
                        this.userPermission = []
                        for (let i = 0; i < data.data.length; i++) {
                            this.userPermission.push({
                                "id"          :  data.data[i]._id,
                                "no"          : (i + 1).toString(),
                                "employee_id" : data.data[i].emp_id,
                                "business"    : data.data[i].business_name,
                                "permission"  : data.data[i].permission.inbox,
                                "created_at"  : MainFunction.shortDate(data.data[i].created_at).replace(/\//g, "."),
                                "name"        : `${data.data[i].emp_name.first_name_th || ''} ${data.data[i].emp_name.last_name_th || ''}`,
                            })
                        }
                    } else {
                        this.userPermission = []
                    }
                } catch (error) {
                    console.log(error)
                    this.userPermission = []
                    this.alert('เกิดข้อผิดพลาด', 'Fail', 'error')
                } finally {
                    this.isReady = true
                    this.callApiPending--
                    this.holdUserPermission = this.userPermission
                        if (this.keyword.trim()) {
                        this.searchKeyword(this.keyword)
                    }
                }
            },
            async deletePermission(id = '') {
                if (!id) {
                    return
                }
                try {
                    this.callApiPending++
                    const { data } = await this.axios.put(`${this.$api_url}/permission/api/v1/delete_permission/${id}`)
                    if (data.status && data.message.toLowerCase().replace(/ /g, "") === 'deletesuccessfully') {
                        this.alert('ลบสิทธ์สำเร็จ', 'Success', 'success')
                        this.isKeyword = this.searchText
                        await this.searchPermissionEmp()
                    } else {
                        this.alert('ไม่พบสิทธิ์ที่ทำรายการ', 'Fail', 'error')
                    }
                } catch (error) {
                    console.log(error);
                    this.alert('เกิดข้อผิดพลาด', 'Fail', 'error')
                } finally {
                    this.callApiPending--
                }
            },
            searchKeyword(isKeyword) {
                isKeyword = isKeyword.toLowerCase().replace(/ /g, "")
                if (!isKeyword) {
                    return this.userPermission = [...this.holdUserPermission]
                }
                let tempPermission = this.holdUserPermission.filter(e => {
                    const no         = e.no.toString().toLowerCase().replace(/ /g, "")
                    const name       = e.name.toString().toLowerCase().replace(/ /g, "")
                    const business   = e.business.toString().toLowerCase().replace(/ /g, "")
                    const permission = e.permission.toString().toLowerCase().replace(/ /g, "")
                    const created_at = e.created_at.toString().toLowerCase().replace(/ /g, "")
                    const employeeId = e.employee_id.toString().toLowerCase().replace(/ /g, "")
                    return no.includes(isKeyword) || name.includes(isKeyword) || business.includes(isKeyword) || permission.includes(isKeyword) || created_at.includes(isKeyword) || employeeId.includes(isKeyword)
                })
                let forCountNumber = Array.from({ length: tempPermission.length }, (_, i) => ({
                    "id"         : tempPermission[i].id,
                    "no"         : (i + 1).toString(),
                    "employee_id": tempPermission[i].employee_id,
                    "business"   : tempPermission[i].business,
                    "permission" : tempPermission[i].permission,
                    "created_at" : tempPermission[i].created_at,
                    "name"       : tempPermission[i].name
                }));
                this.userPermission = [...forCountNumber]
            },
            async downloadFile() {
                try {
                    const response = await this.axios.get(
                        `${this.$api_url}/report/api/v1/export_permission?tax_id=${this.selectedBiz.tax_id}`,
                        {
                            responseType: 'blob'
                        }
                    );
                    if (response && response.data) {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.download = 'permission_report.xlsx';
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        window.URL.revokeObjectURL(url);
                        this.alert('ดาวน์โหลดรายงานสำเร็จ', 'Success', 'success');
                    }
                } catch (error) {
                    console.error(error);
                    this.alert('เกิดข้อผิดพลาด', 'Error', 'error');
                }
            },
            alert(title = '', text = '', icon = 'info') {
                this.$swal({
                    toast: true,
                    position: "top-end",
                    showConfirmButton: false,
                    timer: 3000,
                    icon: icon,
                    title: `<b class="alert-success-title">${title}</b>`,
                    text:  text,
                    showClass: {
                        popup: 'animate-show-card'
                    },
                    customClass: {
                        container: 'alert-card-block',
                        popup: 'alert-card-success',
                        title: 'alert-title-block',
                        htmlContainer: 'alert-text-box',
                        icon: 'alert-icon'
                    }
                });
            }
        }
    }
</script>

<style>
    .background-setting-card {
        background: #FFFFFF;
        border-radius: 23px;
        box-shadow: 0px 4px 50px rgba(0, 0, 0, 0.25);
        margin: 60px 4.5% 30px 4.5%;
    }

    .setting-page-data-table .v-data-table__wrapper table .v-data-table-header tr th {
        background-color: #EEEEEE;
        box-shadow: none;
        height: 57px;
    }

    .setting-page-data-table .v-data-table__wrapper table tbody tr td {
        font-size: 17px;
        background-color: #FAFAFA;
        border-bottom: none !important;
    }

    .search-role-setting input {
        line-height: 30px;
    }

    .setting-page-data-table {
        border-radius: 10px;
        overflow-y: auto;
    }

    .setting-page-data-table thead th:first-child {
        border-radius: 10px 0 0 0;
    }

    .setting-page-data-table thead th:last-child {
        border-radius: 0 10px 0 0;
    }

    .setting-page-data-table .v-data-table__wrapper table thead tr th {
        font-size: 17px;
    }

    .setting-page-data-table.v-data-table > .v-data-table__wrapper {
        height: calc(100vh - 224px);
        overflow: auto;
        background-color: #FAFAFA;
    }

    .setting-page-data-table > .v-data-table__wrapper > table > thead > tr > th {
        color: black !important;
    }

    .setting-page-data-table .v-data-table__wrapper table tbody tr td {
        height: 43px;
    }

    .setting-page-data-table.v-data-table > .v-data-table__wrapper::-webkit-scrollbar-track {
        border-radius: 10px;
        background-color: transparent !important;
    }

    .setting-page-data-table.v-data-table > .v-data-table__wrapper::-webkit-scrollbar {
        width: 8px;
        height: 8px;
        background-color: transparent !important;
    }

    .setting-page-data-table.v-data-table > .v-data-table__wrapper::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background-color: #F5F5F5;
    }

    .decorate-search-btn-setting {
        box-shadow: none;
    }

    @media only screen and (max-width: 900px) {

        .setting-page-data-table .v-data-table__wrapper table tbody tr td:last-child {
            border-bottom: 3px solid rgba(0, 0, 0, 0.12) !important;
        }

        .setting-page-data-table .v-data-table__wrapper table tbody tr:last-child td {
            border-bottom: none !important;
        }

        .setting-page-data-table .v-data-table__wrapper table tbody .v-data-table__empty-wrapper td:last-child {
            border-bottom: none !important;
        }

        .setting-page-data-table .v-data-table__empty-wrapper {
            display: flex;
            justify-content: center;
        }
    }
</style>